import { PlantSpecies } from './plants';

export interface CombinationRecipe {
  plant1: string;          // plant id
  plant2: string;          // plant id
  result: PlantSpecies;    // the hybrid plant produced
  resultName: string;
}

export const RECIPES: CombinationRecipe[] = [
  {
    plant1: 'apple_tree',
    plant2: 'pear_tree',
    resultName: 'Peapple',
    result: {
      id: 'peapple',
      name: 'Peapple',
      type: 'day',
      growthTime: 50,
      waterNeeds: 3,
      attackPower: 22,
      defensePower: 30,
      specialAbility: 'Mutant Barrage',
      description:
        'A bizarre mutant hybrid of apple and pear. Its misshapen fruit explodes on impact, combining offensive volleys with a tough rind shield.',
      spriteRow: 6,
    },
  },
  {
    plant1: 'sunflower',
    plant2: 'moonbloom',
    resultName: 'Twilight Blossom',
    result: {
      id: 'twilight_blossom',
      name: 'Twilight Blossom',
      type: 'both',
      growthTime: 45,
      waterNeeds: 3,
      attackPower: 20,
      defensePower: 20,
      specialAbility: 'Eclipse Pulse',
      description:
        'Born from the union of sun and moon, this flower thrives at all hours. Emits pulses of twilight energy that both damage foes and bolster allies.',
      spriteRow: 7,
    },
  },
  {
    plant1: 'fire_pepper',
    plant2: 'shadow_vine',
    resultName: 'Infernal Creeper',
    result: {
      id: 'infernal_creeper',
      name: 'Infernal Creeper',
      type: 'both',
      growthTime: 55,
      waterNeeds: 2,
      attackPower: 40,
      defensePower: 8,
      specialAbility: 'Hellfire Lash',
      description:
        'A terrifying fusion of fire and darkness. Its burning tendrils lash out from the shadows, delivering extreme damage to anything they touch.',
      spriteRow: 8,
    },
  },
  {
    plant1: 'sunflower',
    plant2: 'fire_pepper',
    resultName: 'Solar Flare',
    result: {
      id: 'solar_flare',
      name: 'Solar Flare',
      type: 'day',
      growthTime: 40,
      waterNeeds: 5,
      attackPower: 45,
      defensePower: 5,
      specialAbility: 'Corona Eruption',
      description:
        'The fury of the sun made manifest. Channels concentrated solar energy into a massive eruption that scorches everything in its path.',
      spriteRow: 9,
    },
  },
  {
    plant1: 'moonbloom',
    plant2: 'shadow_vine',
    resultName: 'Void Orchid',
    result: {
      id: 'void_orchid',
      name: 'Void Orchid',
      type: 'night',
      growthTime: 50,
      waterNeeds: 1,
      attackPower: 12,
      defensePower: 42,
      specialAbility: 'Abyssal Ward',
      description:
        'A hauntingly beautiful orchid that blooms in absolute darkness. Generates an impenetrable ward of void energy, absorbing nearly all incoming attacks.',
      spriteRow: 10,
    },
  },
];
